/* EYF 2026-10-29 (light header): the country pickers (header dropdown, menu drawer, footer) are rendered with only the shopper's own
   country (snippets/localization-form.liquid). The first time a shopper reaches for a picker (hover, tap, focus), the full list is
   fetched once from sections/eyf-countries.liquid and put into every picker on the page; search, keyboard and selection then work as
   before (Horizon's localization-form-component reads the rows through its refs). If the request fails, the next reach tries again. */
(() => {
  if (window.__eyfCountries) return;
  window.__eyfCountries = true;
  const PENDING = 'ul[data-eyf-countries="pending"]';
  const PICKERS = 'dropdown-localization-component, drawer-localization-component, localization-form-component';
  let job = null;

  function fill(rows) {
    document.querySelectorAll(PENDING).forEach((ul) => {
      ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      const frag = document.createDocumentFragment();
      rows.forEach((li) => frag.append(document.importNode(li, true)));
      ul.append(frag);
      ul.dataset.eyfCountries = 'loaded';
      const form = ul.closest('localization-form-component');
      if (form && typeof form.updatedCallback === 'function') form.updatedCallback();
      if (form && form.refs && form.refs.search && form.refs.search.value && typeof form.filterCountries === 'function') form.filterCountries();
    });
  }

  function load() {
    if (job || !document.querySelector(PENDING)) return job;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    job = fetch(`${root}?section_id=eyf-countries`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
      .then((html) => {
        const rows = [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('li[data-value]')];
        if (!rows.length) throw new Error('no countries');
        fill(rows);
      })
      .catch(() => { job = null; });
    return job;
  }

  const reach = (e) => { if (e.target instanceof Element && e.target.closest(PICKERS)) load(); };
  ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach((ev) => document.addEventListener(ev, reach, { passive: true, capture: true }));
})();
